export enum InboxPageMobileView {
  ConversationList = 'ConversationList',
  MessageList = 'MessageList',
}
